/**
 * Created by piotr@revisual.io on 28/07/2025
 */
import { useEffect, useState } from "react";

const getOGTagValue = (tagName) => {
  const tag = document.querySelector(`meta[property="${tagName}"]`);
  return tag ? tag.getAttribute("content") : "";
};

const setOGTagValue = (tagName, value) => {
  let tag = document.querySelector(`meta[property="${tagName}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("property", tagName);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", value);
};

const getCanonicalTagValue = () => {
  const tag = document.querySelector('link[rel="canonical"]');
  return tag ? tag.getAttribute("href") : "";
};

const setCanonicalTagValue = (value) => {
  let tag = document.querySelector('link[rel="canonical"]');
  if (!tag) {
    tag = document.createElement("link");
    tag.setAttribute("rel", "canonical");
    document.head.appendChild(tag);
  }
  tag.setAttribute("href", value);
};

/**
 * OGData component to manage Open Graph and SEO tags dynamically.
 * @param {string} title
 * @param {string} image
 * @param {string} description
 * @param {string} url
 * @param {Object} seoSettings
 * @param {string} seoSettings.title
 * @param {string} seoSettings.description
 * @param {string} seoSettings.alternate
 * @constructor
 */
const OGData = ({ title, image, description, url, seoSettings }) => {
  const [initialValues, setInitialValues] = useState({
    pageTitle: "",
    pageDescription: "",
    ogTitle: "",
    ogImage: "",
    ogDescription: "",
    ogUrl: "",
    canonical: "",
  });

  useEffect(() => {
    setInitialValues({
      ogTitle: getOGTagValue("og:title"),
      ogDescription: getOGTagValue("og:description"),
      ogImage: getOGTagValue("og:image"),
      ogUrl: getOGTagValue("og:url"),
      canonical: getCanonicalTagValue("canonical"),
      pageTitle: document.title,
      pageDescription: document.querySelector('meta[name="description"]')
        ? document
            .querySelector('meta[name="description"]')
            .getAttribute("content")
        : "",
    });

    const formattedTitle = `${title}${seoSettings.title ? " - " : ""}${
      seoSettings.title || ""
    }`;

    const fullUrl = window.location.origin + url;

    setOGTagValue("og:title", formattedTitle);
    setOGTagValue("og:description", description);
    setOGTagValue("og:image", image);
    setOGTagValue("og:url", fullUrl);
    setCanonicalTagValue(fullUrl);
    document.title = formattedTitle;
    const descriptionMeta = document.querySelector('meta[name="description"]');

    if (descriptionMeta) {
      descriptionMeta.setAttribute("content", description);
    }

    return () => {
      setOGTagValue("og:title", initialValues.ogTitle);
      setOGTagValue("og:description", initialValues.ogDescription);
      setOGTagValue("og:image", initialValues.ogImage);
      setOGTagValue("og:url", initialValues.ogUrl);
      setCanonicalTagValue(initialValues.canonical);
      document.title = initialValues.pageTitle;
      const descriptionMeta = document.querySelector(
        'meta[name="description"]'
      );

      if (descriptionMeta) {
        descriptionMeta.setAttribute("content", initialValues.pageDescription);
      } else {
        const newMeta = document.createElement("meta");
        newMeta.setAttribute("name", "description");
        newMeta.setAttribute("content", initialValues.pageDescription);
        document.head.appendChild(newMeta);
      }
    };
  }, []);

  return null;
};

export default OGData;
